import { render, staticRenderFns } from "./benefits-point-reward-panel.vue?vue&type=template&id=3c823f94&scoped=true"
import script from "./benefits-point-reward-panel.vue?vue&type=script&lang=js"
export * from "./benefits-point-reward-panel.vue?vue&type=script&lang=js"
import style0 from "./benefits-point-reward-panel.vue?vue&type=style&index=0&id=3c823f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c823f94",
  null
  
)

export default component.exports